export default 'Subscribe to receive marketing communications about our latest features, partnerships and best practices.'
